<template>
  <main id="app">
    <div
      v-if="alert.message"
      :class="`alert ${alert.type}`"
    >
      <div v-if="alert.message.statusCode === 400">
        Nom d'utilisateur ou mot de passe incorrect
      </div>
      <div v-else-if="alert.message.statusCode === 500">
        Une erreur est survenue
      </div>
      <div v-else-if="alert.message.statusCode === 403">
        Vous n'avez pas les autorisations nécessaires pour ce site, pour demander les autorisations veuillez les demander par e-mail au dpsm-si@brgm.fr
      </div>
      <div v-else-if="alert.message.message">
        {{ alert.message.message }}
      </div>
      <div v-else>
        Une erreur inattendue est survenue
      </div>
    </div>
    <component :is="layout">
      <router-view />
    </component>
  </main>
</template>
<script>
require('@/assets/css/site.css')
require('@/assets/css/materialize-1.0.0.min.css')
/*require('@/assets/js/materialize-1.0.0.min.js')*/
require('@/assets/css/roboto.css')

const defaultLayout = 'default'

import 'floating-vue/dist/style.css'
export default {
    name: 'App',
    computed: {
        layout () {
            return (this.$route.meta.layout || defaultLayout) + '-layout'
        },
        alert() {
            const alert = this.$store.state.alert;
            return alert;
        }
    },
    watch: {
        $route (to, from) {
            this.$store.dispatch('alert/clear')
        }
    },
}
</script>
<style>
    /* Ici on vient contrebalancer la perte de materialize.js*/
    select {
        display: unset;
    }
    .input-field label {
        top: -2.5rem;
    }
    .modal-sans-materialize {
        display: none;
        position: fixed;
        left: 20vw;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
        background-color: #fafafa;
        padding: 0;
        max-height: 70%;
        width: 55%;
        margin: auto;
        overflow-y: auto;
        border-radius: 2px;
        will-change: top, opacity;
        box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
    }
</style>
